<template>
  <div>
    <v-app-bar fixed app>
      <v-app-bar-nav-icon dark @click.stop="drawer = !drawer" />
      <v-spacer></v-spacer>
      <v-avatar class="mr-3">
        <v-img :src="session.data.logo"></v-img>
      </v-avatar>
      <v-toolbar-title>{{ session.data.name }}</v-toolbar-title>
    </v-app-bar>
    <v-navigation-drawer
      v-model="drawer"
      dark
      fixed
      app
      style="height:100%"
      :width="270"
    >
      <v-list rounded dense>
        <v-list-item>
          <v-col>
            <v-img
              :src="require('@/assets/LogoBetask.svg')"
              max-width="70px"
            ></v-img>
          </v-col>
          <v-col>
            <v-img
              class="ml-1 mr-9"
              :src="require('@/assets/GroupBetask.svg')"
              max-width="80px"
            ></v-img>
          </v-col>
        </v-list-item>
      </v-list>
      <v-list rounded dense>
        <!-- <v-list-item to="/Core/Home">
          <v-list-item-icon>
            <v-icon color="white">mdi-view-grid</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">Dashboard</v-list-item-title>
        </v-list-item> -->
        <!-- <v-list-item to="/DashBroad" v-if="session.data.userTypeGroup === 'Shop Admin'">
          <v-list-item-icon>
            <v-icon color="white">mdi-monitor-dashboard</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">DashBroad</v-list-item-title>
        </v-list-item> -->
        <v-list-item to="/Master/AddCoin">
          <v-list-item-icon>
            <v-icon color="white">mdi-alpha-c-box</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">เพิ่มเหรียญ</v-list-item-title>
        </v-list-item>
        <v-list-item to="/Master/Redeem">
          <v-list-item-icon>
            <v-icon color="white">mdi-gift</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">แลกของรางวัล</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item to="/Master/Redeem">
          <v-list-item-icon>
            <v-icon color="white">mdi-ticket-confirmation</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">รับของรางวัล</v-list-item-title>
        </v-list-item> -->
        <v-list-item to="/Core/ReportActivity">
          <v-list-item-icon>
            <v-icon color="white">mdi-view-grid</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">รายงานกิจกรรม</v-list-item-title>
        </v-list-item>
        <!-- <v-list-item to="/Core/PackageMain">
          <v-list-item-icon>
            <v-icon color="white">mdi-package</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head">รายงานแพคเกจ</v-list-item-title>
        </v-list-item> -->
        <v-list-item
          to="/Core/VGroupShortcuts"
          v-if="
            this.session.data.shopId === 'Uc520945108b983b6e739ed0a8cd8dae4'
          "
        >
          <v-list-item-icon>
            <v-icon color="white">mdi-square-inc-cash</v-icon>
          </v-list-item-icon>
          <v-list-item-title class="menu-head"
            >VGroup Shortcut</v-list-item-title
          >
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-graph-outline"
          color="white"
          no-action
          v-if="broadCast.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"
              >เครื่องมือการตลาด</v-list-item-title
            >
          </template>

          <v-list-item
            v-for="(item, i) in broadCast"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="item.title"
              dense
              color="white"
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-shopping"
          color="white"
          no-action
          v-if="master.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"
              >จัดการข้อมูลร้าน</v-list-item-title
            >
          </template>

          <v-list-item
            dense
            v-for="(item, i) in master"
            :key="i"
            :to="item.to"
            router
            exact
          >
            <v-list-item-icon>
              <v-icon
                v-text="item.icon"
                dense
                color="white"
                class="white--text"
              ></v-icon>
            </v-list-item-icon>
            <v-list-item-title dense v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-qrcode-scan"
          color="white"
          no-action
          v-if="tool.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">จัดการคะแนน</v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in tool"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title
              v-text="item.title"
              dense
              color="white"
            ></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-toolbox "
          color="white"
          no-action
          v-if="system.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"
              >จัดการข้อมูลระบบ</v-list-item-title
            >
          </template>

          <v-list-item
            v-for="(item, i) in system"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title dense v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-file-document"
          color="white"
          no-action
          v-if="report.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"
              >รายงาน</v-list-item-title
            >
          </template>

          <v-list-item
            v-for="(item, i) in report"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title dense v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <!-- <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-package-variant "
          color="white"
          no-action
          v-if="Package.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">แพคเกจ</v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in Package"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title dense v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-account-multiple "
          color="white"
          no-action
          v-if="Package.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head"
              >จัดการสมาชิก</v-list-item-title
            >
          </template>

          <v-list-item
            v-for="(item, i) in ManageUser"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title dense v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group> -->
        <v-list-group
          dense
          :value="true"
          prepend-icon="mdi-toolbox "
          color="white"
          no-action
          v-if="game.length > 0"
        >
          <template v-slot:activator>
            <v-list-item-title class="menu-head">เกมส์</v-list-item-title>
          </template>

          <v-list-item
            v-for="(item, i) in game"
            :key="i"
            :to="item.to"
            router
            exact
            dense
          >
            <v-list-item-icon>
              <v-icon v-text="item.icon" dense color="white"></v-icon>
            </v-list-item-icon>
            <v-list-item-title dense v-text="item.title"></v-list-item-title>
          </v-list-item>
        </v-list-group>
      </v-list>
      <template v-slot:append>
        <v-divider class="ma-0"></v-divider>
        <div class="pa-2 nav-button">
          <!-- <v-btn
            block
            text
            tile
            dark
            class="nav-button-dark"
            @click.prevent="chkPlane()"
          >
            <v-icon color="white">mdi-briefcase-edit-outline</v-icon
            >&nbsp;&nbsp;จัดการแพคเกจ
          </v-btn> -->
          <!-- <v-divider class="ma-0"></v-divider> -->
          <v-btn block text tile class="nav-button" @click.prevent="logout()">
            <v-icon color="white">mdi-logout</v-icon>&nbsp;&nbsp;ออกจากระบบ
          </v-btn>
        </div>
      </template>
      <v-dialog v-model="dialogCash" max-width="50%">
        <v-card>
          <v-card-title class="text-h5">
            Be-Loyalty billing plans
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col col="6">
                <v-container class="test-hover">
                  <v-card>
                    <v-row>
                      <v-col col="12">
                        <v-list two-line style="background-color: #1b437c">
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-projector-screen-outline
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title
                                >ระบบที่สามารถใช้งานได้</v-list-item-title
                              >
                              <v-list-item-subtitle class="feature_detail"
                                >สามารถใช้ได้ทั้งหมด</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-account-group
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>จำนวนสมาขิก</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >จำกัดแค่ 100 คน</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-cash-multiple
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>ราคา</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >ฟรี</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <div v-if="!btFree" class="text-center plan_button">
                      <v-btn
                        rounded
                        color="primary"
                        class="ma-1"
                        dark
                        @click="updateFreePlan()"
                      >
                        เปลี่ยนแพลน
                      </v-btn>
                    </div>
                    <div v-if="btFree" class="text-center plan_button">
                      <v-btn
                        rounded
                        outlined
                        style="color:teal !important"
                        class="ma-2"
                      >
                        <p style="margin-bottom: 1px !important; color: teal">
                          แพลนปัจจุบัน
                        </p>
                      </v-btn>
                    </div>
                  </v-card>
                </v-container>
              </v-col>
              <v-col col="6">
                <v-container class="test-hover">
                  <v-card>
                    <v-row>
                      <v-col col="12">
                        <v-list two-line style="background-color: #1b437c">
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-projector-screen-outline
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title
                                >ระบบที่สามารถใช้งานได้</v-list-item-title
                              >
                              <v-list-item-subtitle class="feature_detail"
                                >สามารถใช้ได้ทั้งหมด</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-account-group
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>จำนวนสมาชิก</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >ไม่จำกัดจำนวน</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                          <v-list-item>
                            <v-list-item-icon>
                              <v-icon color="white">
                                mdi-cash-multiple
                              </v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                              <v-list-item-title>ราคา</v-list-item-title>
                              <v-list-item-subtitle class="feature_detail"
                                >฿ 2,999 ต่อเดือน</v-list-item-subtitle
                              >
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </v-col>
                    </v-row>
                    <div v-if="!btBilling" class="text-center plan_button">
                      <v-btn
                        rounded
                        color="primary"
                        dark
                        class="ma-2"
                        @click="billingPlan()"
                      >
                        เปลี่ยนแพลน
                      </v-btn>
                    </div>
                    <div v-if="btBilling" class="text-center plan_button">
                      <v-btn rounded outlined color="teal" dark class="ma-2">
                        <p style="margin-bottom: 0px !important; color: teal">
                          แพลนปัจจุบัน
                        </p>
                      </v-btn>
                    </div>
                  </v-card>
                </v-container>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data () {
    return {
      title: 'Loyalty',
      drawer: true,
      mini: false,
      session: this.$session.getAll(),
      system: [],
      master: [],
      tool: [],
      broadCast: [],
      Package: [],
      ManageUser: [],
      game: [],
      items: [],
      report: [],
      dialogCash: false,
      btFree: false,
      btBilling: false
    }
  },
  computed: {},
  beforeDestroy() {
    // เคลียร์ setTimeout เมื่อคอมโพเนนต์ถูกทำลาย
    clearTimeout(this.timeoutId);
  },
  mounted () {
    this.items = []
    if (this.session.data.userTypeGroup === 'Admin') {
      this.adminChk()
    }
    if (this.session.data.userTypeGroup === 'Shop Admin') {
      this.shopAdminChk()
    }
    if (this.session.data.userTypeGroup === 'Operation') {
      this.operationChk()
    }
    this.$OmiseCard.configure({
      publicKey: this.$omise_public_key
    })
  },
  methods: {
    logout () {
      console.log(this.$session.getAll())
      // this.$session.destroy()
      // this.$session.clear()
      this.$router.push('/Core/Login')
    },
    adminChk () {
      this.report = [
        {
          title: 'รายงานแลกคะแนนสำหรับบริจาค', icon: '', to: '/ReportRedeemDonationPoints'
        }
      ]
      this.system = [
        { title: 'บัญชี', icon: 'mdi-account-edit', to: '/System/User' },
        {
          title: 'เพิ่มร้านค้า',
          icon: 'mdi-cash-register',
          to: '/System/Shop'
        },
        {
          title: 'รายชื่อร้านค้า',
          icon: 'mdi-playlist-check',
          to: '/System/ListAllShop'
        },
        {
          title: 'กลุ่มผู้ใช้งาน',
          icon: 'mdi-account-group',
          to: '/System/UserTypeGroup'
        }
        // {
        //   title: 'จัดการ Api สำหรับแจกคะแนน',
        //   icon: 'mdi-plus-circle-multiple-outline',
        //   to: '/System/ManageApi'
        // }
      ]
      this.master = [
        { title: 'สาขา', icon: 'mdi-home-floor-b', to: '/Master/Branch' },
        {
          title: 'ปรับสีร้านค้า',
          icon: 'mdi-format-color-fill',
          to: '/Master/Color'
        },
        {
          title: 'ระดับบัตรสมาชิก',
          icon: 'mdi-signal-cellular-3',
          to: '/Master/Level'
        },
        {
          title: 'สินค้า/บริการ',
          icon: 'mdi-atom-variant',
          to: '/Master/ProductExchangeRate'
        },
        {
          title: 'โปรโมชั่น',
          icon: 'mdi-ticket-percent',
          to: '/Master/Promotion'
        },
        {
          title: 'Friend Get Friend',
          icon: 'mdi-account-multiple-plus',
          to: '/System/Friendgetfriend'
        },
        {
          title: 'Special Point',
          icon: 'mdi-hand-pointing-right',
          to: '/System/pointFree'
        }

        // { title: 'บทความ', icon: 'mdi-blogger', to: '/Master/blog' },/
        // { title: 'Package', icon: '', to: '/Master/Package' }
      ]
      this.tool = [
        // {
        //   title: 'นำเข้าข้อมูลคะแนน',
        //   icon: 'mdi-table-arrow-left',
        //   to: '/Tool/GivePointM'
        // },
        // {
        //   title: 'Qr Code เก็บคะแนน',
        //   icon: 'mdi-alpha-c-box',
        //   to: '/Tool/CollectQRCode'
        // },
        {
          title: 'Qr Code Lot',
          icon: 'mdi-book-plus-multiple',
          to: '/Tool/CollectQRCodeLot'
        }
      ]
      this.broadCast = [
        {
          title: 'กลุ่มเป้าหมาย',
          icon: 'mdi-account-group',
          to: '/BroadCast/Audience'
        },
        {
          title: 'บรอดแคสต์',
          icon: 'mdi-bullhorn',
          to: '/BroadCast/BroadCast'
        },
        { title: 'ของรางวัล', icon: 'mdi-gift-open', to: '/Master/Reward' },
        { title: 'กิจกรรม', icon: 'mdi-account-voice', to: '/Tool/Activity' },
        {
          title: 'ติดตามการจัดส่ง',
          icon: 'mdi-stocking',
          to: '/System/Transport'
        }
      ]
      this.Package = [
        { title: 'จัดการแพคเกจ', icon: 'mdi-package', to: '/Master/Package' }
        //   { title: 'ซื้อแพคเกจ', icon: 'mdi-qrcode', to: '/Master/PackageQRcode' }
      ]
      //   this.ManageUser = [
      //     {
      //       title: 'ติดตามการจัดส่ง',
      //       icon: 'mdi-stocking',
      //       to: '/System/Transport'
      //     }
      //   ]
      //   this.game = [
      //     { title: 'เกมส์', icon: 'mdi-gamepad-variant', to: '/Game/NameGame' }
      //   ]
    },
    shopAdminChk () {
      this.report = [
        {
          title: 'รายงานแลกคะแนนสำหรับบริจาค', icon: '', to: '/ReportRedeemDonationPoints'
        },
        {
          title: 'รายงานแลกของรางวัล',
          icon: '',
          to: '/Tool/ReportCode'
        }
      ]
      this.system = [
        { title: 'บัญชี', icon: 'mdi-account-edit', to: '/System/User' },
        { title: 'ร้านค้า', icon: 'mdi-cash-register', to: '/System/EditShop' },
        {
          title: 'รายการ ลูกค้า',
          icon: 'mdi-account-details',
          to: '/System/ListMember'
        }
        // ,
        // {
        //   title: 'จัดการ Api สำหรับแจกคะแนน',
        //   icon: 'mdi-plus-circle-multiple-outline',
        //   to: '/System/ManageApi'
        // }
      ]
      this.master = [
        { title: 'สาขา', icon: 'mdi-home-floor-b', to: '/Master/Branch' },
        {
          title: 'ปรับสีร้านค้า',
          icon: 'mdi-format-color-fill',
          to: '/Master/Color'
        },
        {
          title: 'ระดับบัตรสมาชิก',
          icon: 'mdi-signal-cellular-3',
          to: '/Master/Level'
        },
        {
          title: 'สินค้า/บริการ',
          icon: 'mdi-atom-variant',
          to: '/Master/ProductExchangeRate'
        },
        {
          title: 'โปรโมชั่น',
          icon: 'mdi-ticket-percent',
          to: '/Master/Promotion'
        },
        // {
        //   title: 'โปรโมชั่น',
        //   icon: 'mdi-ticket-percent',
        //   to: '/Master/Promotion'
        // },
        {
          title: 'Friend Get Friend',
          icon: 'mdi-account-multiple-plus',
          to: '/System/Friendgetfriend'
        },
        {
          title: 'Special Point',
          icon: 'mdi-hand-pointing-right',
          to: '/System/pointFree'
        }

        // { title: 'บทความ', icon: 'mdi-blogger', to: '/Master/blog' }
      ]
      this.tool = [
        // {
        //   title: 'นำเข้าข้อมูลคะแนน',
        //   icon: 'mdi-table-arrow-left',
        //   to: '/Tool/GivePointM'
        // },
        // {
        //   title: 'Qr Code เก็บคะแนน',
        //   icon: 'mdi-alpha-c-box',
        //   to: '/Tool/CollectQRCode'
        // },
        {
          title: 'Qr Code Lot',
          icon: 'mdi-book-plus-multiple',
          to: '/Tool/CollectQRCodeLot'
        },
        { title: 'ดึงคะแนนกลับ', icon: 'mdi-cash-refund', to: '/Tool/Refund' }
      ]
      this.broadCast = [
        {
          title: 'กลุ่มเป้าหมาย',
          icon: 'mdi-account-group',
          to: '/BroadCast/Audience'
        },
        {
          title: 'บรอดแคสต์',
          icon: 'mdi-bullhorn',
          to: '/BroadCast/BroadCast'
        },
        { title: 'ของรางวัล', icon: 'mdi-gift-open', to: '/Master/Reward' },
        { title: 'กิจกรรม', icon: 'mdi-account-voice', to: '/Tool/Activity' },
        {
          title: 'ติดตามการจัดส่ง',
          icon: 'mdi-stocking',
          to: '/System/Transport'
        }
      ]
      this.Package = [
        { title: 'จัดการแพคเกจ', icon: 'mdi-package', to: '/Master/Package' }
        //     { title: 'ซื้อแพคเกจ', icon: 'mdi-qrcode', to: '/Master/PackageQRcode' }
      ]
      this.ManageUser = [
        {
          title: 'ติดตามการจัดส่ง',
          icon: 'mdi-stocking',
          to: '/System/Transport'
        }
      ]
      //   this.game = [
      //     { title: 'เกมส์', icon: 'mdi-gamepad-variant', to: '/Game/NameGame' }
      //   ]
    },
    operationChk () {
      this.system = [
        {
          title: 'รายการ ลูกค้า',
          icon: 'mdi-account-details',
          to: '/System/ListMember'
        }
      ]
      this.tool = [
        // {
        //   title: 'นำเข้าข้อมูลคะแนน',
        //   icon: 'mdi-table-arrow-left',
        //   to: '/Tool/GivePointM'
        // },
        {
          title: 'Qr Code เก็บคะแนน',
          icon: 'mdi-alpha-c-box',
          to: '/Tool/CollectQRCode'
        },
        {
          title: 'Qr Code Lot',
          icon: 'mdi-book-plus-multiple',
          to: '/Tool/CollectQRCodeLot'
        }
      ]
    },
    async chkPlane () {
      await axios
        .get(
          this.DNS_IP +
            '/system_shop/get?shopId=' +
            this.$session.getAll().data.shopId
        )
        .then(async response => {
          let rs = response.data[0]
          console.log(rs)
          if (response.data.length > 0) {
            // console.log('shop', response.data[0])
            if (rs.billingPlan === 'free') {
              this.btFree = true
              this.btBilling = false
            } else {
              this.btFree = false
              this.btBilling = true
            }
          }
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
      this.dialogCash = true
    },
    billingPlan () {
      this.$swal({
        title: 'ต้องการ อัพเดทสมาชิก ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          console.log('test', this.$OmiseCard)
          this.$OmiseCard.open({
            frameLabel: 'Be-Loyalty',
            amount: 200000,
            currency: 'THB',
            defaultPaymentMethod: 'credit_card',
            onCreateTokenSuccess: nonce => {
              if (nonce.startsWith('tokn_')) {
                this.omiseToken = nonce
                this.getCustomersOmise(nonce)
              } else {
                this.omiseSource = nonce
              }
              // form.submit()
            }
          })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
      console.log('test', this.$session.getAll().data)
      this.dialogCash = true
    },
    async getCustomersOmise (tokn) {
      console.log('tokn', tokn)
      var dt = {
        email: this.$session.getAll().data.userEmail,
        description: this.$session.getAll().data.name,
        card: tokn,
        shopId: this.$session.getAll().data.shopId
      }
      await axios
        .post(this.DNS_IP + '/omise/customers', dt)
        .then(async response => {
          console.log('getCustomersOmise', response)
          if (response.data.status) {
            this.chkPlane()
            // setTimeout(this.$router.go(), 60000)
            this.$swal(
              'เรียบร้อย',
              'คุณได้อัพเดทเป็นสมาชิก Premium แล้ว',
              'success'
            )
            setTimeout(() => {
              this.redirexPage()
            }, 1500)

            //   .then(async response => {
            //     this.$swal({
            //       title: 'ต้องการ เปลี่ยนแพคเกจ ใช่หรือไม่?',
            //       type: 'question',
            //       showCancelButton: true,
            //       confirmButtonColor: '#3085d6',
            //       cancelButtonColor: '#b3b1ab',
            //       confirmButtonText: 'ใช่',
            //       cancelButtonText: 'ไม่'
            //     })
            //   })
          } else {
            this.$swal('ผิดพลาด', 'กรุณาตรวจสอบข้อมูลครับ', 'error')
          }
        })
    },
    updateFreePlan () {
      this.$swal({
        title: 'ต้องการ อัพเดทสมาชิก ใช่หรือไม่?',
        type: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#b3b1ab',
        confirmButtonText: 'ใช่',
        cancelButtonText: 'ไม่'
      })
        .then(async result => {
          var dt = {
            billingPlan: 'free',
            LAST_USER: this.$session.getAll().data.userName,
            billingCustomerId: '',
            billingCustomerCardId: '',
            billingScheduleId: '',
            billingCustomerData: ''
          }
          axios
            .post(
              // eslint-disable-next-line quotes
              this.DNS_IP +
                '/sys_shop/edit-free-billplan/' +
                this.$session.getAll().data.shopId,
              dt
            )
            .then(async response => {
              this.chkPlane()
              this.$swal(
                'เรียบร้อย',
                'คุณได้อัพเดทเป็นสมาชิกสายฟรีแล้ว',
                'success'
              )
              setTimeout(() => {
                this.redirexPage()
              }, 1500)
            })
        })
        .catch(error => {
          this.dataReady = true
          console.log('error function editDataGlobal : ', error)
        })
    },
    redirexPage () {
      this.$router.go()
    }
  }
}
</script>

<style lang="css" scoped>
#img_bt {
  width: 50px;
  height: 50px;
}
.feature_detail {
  color: #ddd !important;
}
.test-hover:hover {
  cursor: pointer;
  border-radius: 10px;
  box-shadow: 0px 8px 28px 11px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0px 8px 28px 11px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0px 8px 28px 11px rgba(0, 0, 0, 0.2);
}
.v-list-item:hover {
  /* background-color: #607EAA; */
  text-decoration: none;
}
.list:active {
  background-color: #607eaa !important;
}
.v-list--dense .v-list-item .v-list-item__subtitle,
.v-list--dense .v-list-item .v-list-item__title,
.v-list-item--dense .v-list-item__subtitle,
.v-list-item--dense .v-list-item__title {
  font-size: 0.8125rem;
  font-weight: 500;
  line-height: 1.5rem;
}
.v-navigation-drawer__content {
  height: 100%;
  width: 1px;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Sidebar.vue